module.exports = __webpack_public_path__ + "static/img/erweima.2082e4b9.png";